import React, { Component } from 'react';
import WithTransition from '../../hoc/WithTransition';
import classNames from 'classnames';
import './dpit-step-meta-data.scss';
import Switch from './../../components/Switch/Switch';
import InfoIcon from './../../components/InfoIcon/InfoIcon';
import { setTippyContentReact } from './../../react-utils';
const i18n = window.dpIntroTourPublicConfig.i18n;


class StepMetaDataContainer extends Component {

	updateAdvancedVal(advVal, paramName, newParamVal) {
		const newVal = { ...advVal };
		if (!newVal.ext) newVal.ext = {};
		newVal.ext[paramName] = newParamVal;
		this.props.onChange(paramName, newVal);
	}



	render() {
		const mainClasses = classNames({
			[this.props.classBEMRoot]: this.props.classBEMRoot,
			[this.props.className]: this.props.className,
		});

		let items = null;
		if (this.props.val?.ext && this.props.definition) {
			items = [];
			const advVal = this.props.val;
			Object.keys(this.props.val.ext).forEach(paramName => {
				const definition = this.props.definition?.[paramName];

				if (definition) {
					let itemComp = null;
					switch (definition.type) {
						case 'checkbox':
							itemComp = (
								<Switch
									className={classNames({
										'dpit-switch--half-size': true
									})}
									options={[{
										displayName: i18n.ON,
										value: '1',
									}, {
										displayName: i18n.OFF,
										value: '0',
									}]}
									selectedOption={advVal.ext[paramName] ?? definition.def ?? '0'}
									onSelectOption={newParamVal => this.updateAdvancedVal(advVal, paramName, newParamVal)}
								/>
							);
							break;
						case 'number':
							{
								itemComp = (
									<input
										type="number"
										className={`${this.props.classBEMRoot}__item__number`}
										value={advVal.ext[paramName] ?? definition.def}
										min={definition.min}
										max={definition.max}
										step={definition.step}
										onChange={event => {
											let { value, min, max } = event.target;
											value = Math.max(Number(min), Math.min(Number(max), Number(value))).toString();

											this.updateAdvancedVal(advVal, paramName, value);
										}}
									>
									</input>
								);
							}
							break;
					}
					if (itemComp) items.push(
						<div className={`${this.props.classBEMRoot}__item`} key={paramName}>
							<div
								className={`${this.props.classBEMRoot}__item__label`}
								dangerouslySetInnerHTML={{ __html: definition.title + ':' }}
							/>
							<div className={classNames({
								[`${this.props.classBEMRoot}__item__comp`]: true,
								[`${this.props.classBEMRoot}__item--${definition.type}`]: definition.type
							})}>
								{itemComp}
							</div>
							<InfoIcon
								classBEMRoot={`${this.props.classBEMRoot}__item__hint`}
								className="dpit-info-icon dpit-info-icon--builder-step-edit"
								infoText={setTippyContentReact(definition.hint)}
							/>
						</div >
					);

				}
			});
		}

		return (
			<div className={mainClasses} title="">

				{this.props.children}
				{items}
			</div>
		);
	}
}

export default StepMetaDataContainer;
export const StepMetaDataContainerWithTransition = WithTransition(StepMetaDataContainer);
